export default "__VITE_ASSET__BaIg0Pqz__"